// extracted by mini-css-extract-plugin
module.exports = {"root":"Wrapper_root__mYLyI","fadeIn":"Wrapper_fadeIn__2n88j","flexbox":"Wrapper_flexbox__kvFLi","glow":"Wrapper_glow__eSIbp"};